import React from 'react';
import PropTypes from 'prop-types';

import Strings from '../../../../Strings';
import { makeValid } from '../../../../utils';
import TableWidget from '../component/TableWidget';
import { PERMISSIONS, canViewCohorts, hasPermission } from '../../../../utils/userPermissions';

function CenterDetails(props) {
  const { centerDetails, providers, facility, cohort, isLoading } = props;
  const data = [];
  data.push([Strings.facility, makeValid(facility)]);
  if (cohort !== undefined && canViewCohorts()) {
    data.push([Strings.cohort, makeValid(cohort)]);
  }

  const providerValues = providers?.length > 0
    ? providers
    : (centerDetails || []).map(cd => cd?.orderingProvider).filter(v => v && `${v}`.trim() !== '');
  if (providerValues.length > 0) {
    providerValues.forEach(provider => {
      data.push([Strings.capPatient.provider, makeValid(provider)]);
    });
  } else {
    data.push([Strings.capPatient.provider, '-']);
  }

  if (centerDetails && centerDetails.length > 0) {
    centerDetails.forEach(cd => {
      data.push([Strings.capPatient.clinicContact, makeValid(cd.clinicContact)]);
    });
  }
  const canEdit = hasPermission(PERMISSIONS.CARE_MANAGEMENT_PATIENT_INFO_EDIT);

  return (
    <TableWidget
      title={Strings.capPatient.centerDetails}
      buttons={props.onEdit && canEdit ? [{ icon: 'edit', onClick: props.onEdit, id: 'edit-center-details-button' }] : undefined}
      data={data}
      isLoading={isLoading}
      firstColumnClassName="center-details-col"
    />
  );
}

CenterDetails.propTypes = {
  isLoading: PropTypes.any,
  centerDetails: PropTypes.arrayOf(
    PropTypes.shape({
      centerName: PropTypes.string,
      provider: PropTypes.string,
      orderingProvider: PropTypes.string,
      clinicContact: PropTypes.string,
    }),
  ),
  providers: PropTypes.arrayOf(PropTypes.string),
  patientId: PropTypes.any,
  onEdit: PropTypes.func,
  facility: PropTypes.string,
  cohort: PropTypes.string,
};
CenterDetails.widgetId = 'CenterDetailsWidget';

export default CenterDetails;
